import { kitStatusColorParser, kitStatusParser, parseDate } from '@repo/utils';
import { Badge, Icon } from 'components';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { getTinyAccountById } from 'store/account';
import { getKitById } from 'store/kits';

import styles from './ConsultBookingCard.module.css';

const KitSelectOption = ({ ...props }) => {
  const kit = useSelector(getKitById(props.value));
  const tinyAccount = useSelector(getTinyAccountById(kit?.tinyaccount_id));
  if (!kit) return null;
  return (
    <div className={styles.kitSelectOption}>
      <div className={styles.iconLabelContainer}>
        <div className={styles.iconContainer}>
          <Icon
            size='m'
            name={kit.sampling_type === 'stool' ? 'swab' : 'lotus'}
          />
        </div>
        <div>
          <div className={styles.kitLabel}>{kit.id}</div>
          {kit.sample_date && (
            <div className={styles.kitSubLabel}>
              {format(parseDate(kit.sample_date), 'MM/dd/yy')}
            </div>
          )}
        </div>
      </div>
      <div className={styles.nameLabel}>{tinyAccount?.first_name}</div>
      <Badge
        title={kitStatusParser(kit.status)}
        state={kitStatusColorParser(kit.status)}
      />
    </div>
  );
};

export default KitSelectOption;
